export const apiUrl = "/api/v1"
export const UserNameGet = "/Vendor/UserName?UserEmail="
export const VendorLogin = "/Vendor/Login"
export const SendEmail = "/Vendor/ForgotPassword?Email="
export const ResetPassword = "/Vendor/ResetPassword"
export const VendorRegister ="/Vendor/Register"
export const VendorValidateSignUpOTP ="/Vendor/ValidateSignUpOTP"
export const VendorDropDown ="/Vendor/VendorDropDownList"
export const VendorStoresDropDown = "/Vendor/VendorStoresList?Id="
export const VendorStoresDropDownCleaningSchedule = "/Vendor/GetStoresForCleaningSchedule?UserId="
export const VendorCleaners = "/Vendor/VendorCleaners"
export const VendorSuccessCleans = "/Vendor/VendorSuccessCleans"
export const VendorMissedCleans = "/Vendor/VendorMissedCleans"
export const VendorsDownloadMissedCleanCSV = "/Vendor/VendorsDownloadMissedCleanCSV"
export const DownloadSuccesssCleanReport = "/Vendor/DownloadSuccessCleanReport"
export const SearchStore = "/Vendor/SearchStore?UserID="
export const UploadCleanerSchedule = "/Vendor/UploadCleanerSchedule?UserId="
export const AddCleanerSchedule = "/Vendor/AddCleanerSchedule?UserID="
export const UpdateCleanerSchedule = "/Vendor/UpdateCleanerSchedule?UserID="
export const DownloadCleanerSchedule = "/Vendor/VendorDownloadCleanerSchedule?UserId="
export const VendorGetFileLogs = "/Vendor/VendorGetFileLogs?UserId="
export const VendorGetAllCleanersCompanies = "/Vendor/VendorGetAllCleanerCompanies?UserId="
export const VendorAddUpdateCleanerCompanies = "/Vendor/VendorAddUpdateCleanerCompanies?UserId="
export const VendorDeleteCleanerCompanies = "/Vendor/DeleteCleanerCompanies?UserId="
export const UpdateUser = "/Vendor/UpdateUser?UserId="
export const SearchUser = "/Vendor/SearchUser?UserId="
export const VendorGetAllusers = "/Vendor/VendorGetAllUsers?UserId="
export const VendorGetAllusersPage = "&Page="